<template>
    <div v-html="updatedSvg"></div>
</template>

<script>
export default {
    props: {
        svgContent: {
            type: String,
        },
        primaryColor: {
            type: String,
        },
        height: {
            type: Number,
            default: null,
        },
        width: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            updatedSvg: "",
        };
    },
    watch: {
        svgContent: "fetchAndUpdateSvg",
        primaryColor: "fetchAndUpdateSvg",
    },
    mounted() {
        this.fetchAndUpdateSvg();
    },
    methods: {
        async fetchAndUpdateSvg() {
            try {
                const response = await fetch(this.svgContent);
                const svgText = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(svgText, "image/svg+xml");
                const elements = doc.querySelectorAll("[fill='#3E9DF0']");
                const svg = doc.documentElement;

                elements.forEach((element) => {
                    element.setAttribute("fill", this.primaryColor);
                });

                if (this.height) {
                    svg.setAttribute("height", this.height);
                }

                if (this.width) {
                    svg.setAttribute("width", this.width);
                }

                const serializer = new XMLSerializer();
                this.updatedSvg = serializer.serializeToString(doc.documentElement);
            } catch (error) {
                console.error("Error fetching or updating SVG:", error);
            }
        },
    },
};
</script>
